import fetchService from '@xanadu/ui-shared/utils/fetchService';

const OPTIONS = {
  headers: {
    'X-Id-Type': 'String',
  },
};

export const fetchCasinoControls = () => fetchService('/casino-api/api/v1/accounts', OPTIONS);

export const submitCasinoRealityCheck = (value, method) => {
  const body = {
    'period-minutes': value,
  };
  return fetchService('/casino-api/api/v1/accounts/reality-check', {
    ...OPTIONS,
    body: JSON.stringify(body),
    method,
  });
};
